import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama"}/>
}
